import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { closeMobileStatisticsPopUp } from "@utils";
import StatisticsIFrame from "./StatisticsIFrame";

export default observer(function StatisticsPopup() {
	const { t } = useTranslation();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);

	if (!searchParams.has("tStatId") && !searchParams.has("eStatId")) {
		return null;
	}

	return (
		<div className="popup popup--full">
			<div className="popup__card popup--full__card">
				<div className="popup__header">
					<div className="popup__title">
						{t("EVENT.HEADER.FULL_STATS")}
					</div>
					<button
						id=""
						onClick={() => closeMobileStatisticsPopUp()}
						className="popup__close btn btn--square btn--square--sml btn--ghost"
					>
						<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
					</button>
				</div>
				<div
					id="statistics-popup-body"
					className="popup__body popup--full__body"
				>
					<StatisticsIFrame
						eStatId={searchParams.get("eStatId") || ""}
						tStatId={searchParams.get("tStatId") || ""}
					/>
				</div>
			</div>
		</div>
	);
});
